import { render, staticRenderFns } from "./InitiateApprovalScreen.vue?vue&type=template&id=b2fcc028&scoped=true"
import script from "./InitiateApprovalScreen.vue?vue&type=script&lang=js"
export * from "./InitiateApprovalScreen.vue?vue&type=script&lang=js"
import style0 from "./InitiateApprovalScreen.vue?vue&type=style&index=0&id=b2fcc028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fcc028",
  null
  
)

export default component.exports